// extracted by mini-css-extract-plugin
module.exports = {"mainSearch":"main-search_mainSearch__k__7n","mobileTagList":"main-search_mobileTagList__8qHi8","desktopFilters":"main-search_desktopFilters__DHCt_"};